import { BOARD_CODE } from ".";

export const MENU = [
  {
    id: "about-us",
    to: "/AboutUs",
    title: "About CDH",
    items: [
      {
        id: "about-us-1",
        to: "/AboutUs/Question",
        title: "CDH, 그것이 궁금하다",
      },
      {
        id: "about-us-2",
        to: "/AboutUs/Communication",
        title: "품속의 아기, 엄마와 소통하다",
      },
      {
        id: "about-us-3",
        to: "/AboutUs/Lifestyle",
        title: "슬기로운 신생아중환자실 생활",
      },
      {
        id: "about-us-4",
        to: "/AboutUs/Story",
        title: "횡격막 수술 이야기",
      },
      {
        id: "about-us-5",
        to: "/AboutUs/Healthy",
        title: "건강한 내일을 위한 첫걸음",
      },
      {
        id: "about-us-6",
        to: "/AboutUs/Goodbye",
        title: "아기를 떠나 보내며",
      },
    ],
  },
  {
    id: "k-cdh",
    to: "/KCDH",
    title: "K-CDH",
    items: [
      {
        id: "k-cdh-1",
        to: "/KCDH/Goal",
        title: "K-CDH 연구 목표",
      },
      {
        id: "k-cdh-2",
        to: "/KCDH/Build",
        title: "K-CDH 구성",
      },
      {
        id: "k-cdh-3",
        to: "/KCDH/Introduction",
        title: "K-CDH 코호트 연구 소개",
      },
    ],
  },
  {
    id: "news",
    to: "/News",
    title: "News",
    boardCode: BOARD_CODE.NOTICE,
    items: [
      {
        id: "news-1",
        to: "/News/Notice",
        title: "공지사항",
        boardCode: BOARD_CODE.NOTICE,
      },
      {
        id: "news-2",
        to: "/News/AnnualReport",
        title: "연차보고서",
        boardCode: BOARD_CODE.ANNUAL_REPORT,
      },
    ],
  },
  {
    id: "family",
    to: "/Family",
    title: "Family",
    boardCode: BOARD_CODE.FAQ,
    items: [
      {
        id: "family-1",
        to: "/Family/Faq",
        title: "FAQ",
        boardCode: BOARD_CODE.FAQ,
      },
      {
        id: "family-2",
        to: "/Family/ForKid",
        title: "우리아기 화이팅",
        boardCode: BOARD_CODE.BABY_CHEER,
      },
      {
        id: "family-3",
        to: "/Family/ForDoctor",
        title: "힘내세요 선생님",
        boardCode: BOARD_CODE.CARE_CHEER,
      },
      {
        id: "family-4",
        to: "/Family/StarKid",
        title: "별이 된 아기들",
        boardCode: BOARD_CODE.BABY_MEMORIAL,
      },
      {
        id: "family-5",
        to: "/Family/GeneralArchive",
        title: "자료실",
        boardCode: BOARD_CODE.GENERAL_RESOURCE,
      },
      {
        id: "family-6",
        to: "/Family/Curious",
        title: "궁금합니다",
        boardCode: BOARD_CODE.QUESTION,
      },
    ],
  },
  {
    id: "research",
    to: "/Research",
    title: "Research",
    requiredAuth: true,
    boardCode: BOARD_CODE.RESEARCH_BOARD,
    items: [
      {
        id: "research-1",
        to: "/Research/MemberBoard",
        title: "연구자 게시판",
        boardCode: BOARD_CODE.RESEARCH_BOARD,
      },
      {
        id: "research-2",
        to: "/Research/MemberArchive",
        title: "연구자 자료실",
        boardCode: BOARD_CODE.RESEARCH_RESOURCE,
      },
      {
        id: "research-3",
        to: "/Research/Idea",
        title: "연구 제안서",
        boardCode: BOARD_CODE.RESEARCH_PROPOSAL,
        items: [
          {
            id: "research-3-edit-1",
            to: "/Research/Idea/Edit01",
            title: "연구 제안서",
            boardCode: BOARD_CODE.RESEARCH_PROPOSAL,
          },
          {
            id: "research-3-edit-2",
            to: "/Research/Idea/Edit01",
            title: "연구 제안서",
            boardCode: BOARD_CODE.RESEARCH_PROPOSAL,
          },
          {
            id: "research-3-write",
            to: "/Research/Idea/New",
            title: "연구 제안서",
            boardCode: BOARD_CODE.RESEARCH_PROPOSAL,
          },
        ],
      },
      {
        id: "research-4",
        to: "/Research/QnA",
        title: "연구등록 Q&A",
        boardCode: BOARD_CODE.RESEARCH_QNA,
      },
    ],
  },
  {
    id: "contact-us",
    to: "/ContactUs",
    title: "Contact Us",
    boardCode: BOARD_CODE.CONTACT,
    items: [
      {
        id: "contact-us-1",
        to: "/ContactUs",
        title: "Contact Us",
        boardCode: BOARD_CODE.CONTACT,
      },
    ],
  },
];

export const FULL_MENU = [
  ...MENU,
  {
    id: "mypage",
    to: "/MyPage",
    title: "My page",
    requiredAuth: true,
    items: [
      {
        id: "my-page-1",
        to: "/MyPage/ChangeInfo",
        title: "내 정보 변경",
      },
      {
        id: "my-page-2",
        to: "/MyPage/ChangeEmail",
        title: "이메일 변경",
      },
      {
        id: "my-page-3",
        to: "/MyPage/ChangePassword",
        title: "비밀번호 변경",
      },
      {
        id: "my-page-4",
        to: "/MyPage/IdeaHistory",
        title: "지난 제안 내역",
        boardCode: BOARD_CODE.RESEARCH_PROPOSAL,
      },
      {
        id: "my-page-5",
        to: "/MyPage/Withdraw",
        title: "회원탈퇴",
      },
    ],
  },
  {
    id: "public",
    to: "/Public",
    title: "K-CDH",
    items: [
      {
        id: "public-1",
        to: "/Public/Privacy",
        title: "개인정보처리방침",
      },
      {
        id: "public-2",
        to: "/Public/Term",
        title: "서비스 이용약관",
      },
    ],
  },
];
